module.exports = __webpack_public_path__ + "static/media/For Web Matter.86e6fe55.pdf";